module.exports = __webpack_public_path__ + "static/media/d-app2.b4d3c548.svg";